import * as React from 'react';

export function QuizIconSVG(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21 11H9C7.89543 11 7 11.8954 7 13V21C7 22.1046 7.89543 23 9 23H21C22.1046 23 23 22.1046 23 21V13C23 11.8954 22.1046 11 21 11Z"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.45 19.05C12.45 18.95 12.45 18.75 12.55 18.55L13.75 15.25C13.95 14.65 14.35 14.35 14.95 14.35C15.65 14.35 16.05 14.65 16.25 15.25L17.45 18.55C17.55 18.75 17.55 18.95 17.55 19.05C17.55 19.45 17.25 19.85 16.75 19.85C16.25 19.85 16.05 19.65 15.95 19.15L15.85 18.75H14.15L14.05 19.05C13.95 19.55 13.65 19.85 13.25 19.85C12.75 19.75 12.45 19.45 12.45 19.05ZM15.55 17.55L14.95 15.65L14.45 17.55H15.55Z"
                fill="#0A2545"
            />
            <path
                d="M7 13H3C1.89543 13 1 12.1046 1 11V3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V10.9"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="9.07495" cy="6.1875" r="2.25" stroke="#0A2545" strokeWidth="1.5" />
            <line
                x1="9.62545"
                y1="6.7688"
                x2="11.5105"
                y2="8.65385"
                stroke="#0A2545"
                strokeWidth="1.4"
                strokeLinecap="round"
            />
        </svg>
    );
}
